import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import formatNumber from 'fns/formatNumber';
import Divider from '@material-ui/core/Divider';
import Accordion from 'components/Accordion/Accordion';
import UsersDialog from 'components/Dialog/UsersDialog/UsersDialog';
import { isMobile } from 'react-device-detect';
import { toFA } from 'fns/toFA';
import { toEN } from 'fns';
import { rond } from 'fns';
import Total from 'components/Total/Total';
import DatePicker from 'components/TextFields/DatePicker';
import { Box, Paper, TextField } from '@material-ui/core';
import Chip from 'components/Chip/Chip/Chip';

const useStyles = makeStyles((theme) => ({
  filtersContainer: {
    display: 'grid',
    gridTemplateColumns: !isMobile ? '1fr 1fr 1fr 1fr' : '1fr',
    gridGap: theme.spacing(1),
  },
}));

const CanceledFilters = ({
  setValues,
  values,
  totalOrder,
  fromDate,
  toDate,
}) => {
  const classes = useStyles();

  const [openUserDialog, setOpenUserDialog] = useState(false);

  const handleChangeFromDate = (date) => {
    setValues((prev) => ({ ...prev, fromDate: date }));
  };
  const handleChangeToDate = (date) => {
    setValues((prev) => ({ ...prev, toDate: date }));
  };
  const handleCloseUserDialog = (data) => {
    if (data) {
      setValues({ ...values, selectedUser: data[0] });
    }
    setOpenUserDialog(false);
  };
  const handleOpenUserDialog = () => {
    setOpenUserDialog(true);
  };
  const handleDeleteUser = () => {
    setValues({ ...values, selectedUser: null });
  };
  return (
    <>
      <UsersDialog
        single
        role={['customer']}
        onChange={handleCloseUserDialog}
        open={openUserDialog}
        closeDialog={handleCloseUserDialog}
      />

      <Accordion title="فیلتر سفارشات">
        <Divider style={{ margin: '15px 0' }} />
        <div className={classes.filtersContainer}>
          <DatePicker
            variant={isMobile ? 'filled' : 'outlined'}
            value={fromDate}
            label="از تاریخ"
            onChange={handleChangeFromDate}
          />
          <DatePicker
            variant={isMobile ? 'filled' : 'outlined'}
            value={toDate}
            label="تا تاریخ"
            onChange={handleChangeToDate}
          />
          <Paper
            // placeholder="انتخاب کاربر"
            onClick={handleOpenUserDialog}
            border={'1px solid rgb(33 37 41 / 45%)'}
            borderRadius={'4px'}
            padding={'8px'}
            style={{
              cursor: 'pointer',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            variant="outlined"
          >
            {values?.selectedUser?.firstName !== undefined ? (
              <Chip
                onDelete={handleDeleteUser}
                label={
                  `${values?.selectedUser?.firstName} ${values?.selectedUser?.lastName}` ||
                  ''
                }
              />
            ) : (
              <div className="text-muted">انتخاب کاربر</div>
            )}
          </Paper>
          <Total
            total={toFA(formatNumber(toEN(rond(totalOrder || 0))))}
            title={'جمع کل شرکت: '}
            backgroundColor={'red'}
          />
        </div>
      </Accordion>
      <Divider style={{ margin: '15px 0' }} />
    </>
  );
};

export default React.memo(CanceledFilters);
